document.addEventListener('DOMContentLoaded', () => {
	const documentArchives = document.querySelectorAll('.document-archive')

	documentArchives.forEach(archive => {
		const yearFilter = archive.querySelector('select[name="year"]')
		const typeFilter = archive.querySelector('select[name="document-type"]')

		const years = archive.querySelectorAll('.documents .year')
		const documents = archive.querySelectorAll('.documents .document')

		yearFilter?.addEventListener('change', () => {
			if (yearFilter.value == 'all') {
				years.forEach(year => {
					year.classList.remove('hide')
				})
			} else {
				years.forEach(year => {
					if (year.dataset.year != yearFilter.value) {
						year.classList.add('hide')
					} else {
						year.classList.remove('hide')
					}
				})
			}
		})

		typeFilter?.addEventListener('change', () => {
			if (typeFilter.value == 'all') {
				documents.forEach(document => {
					document.classList.remove('hide')
				})
			} else {
				documents.forEach(document => {
					if (document.dataset.type != typeFilter.value) {
						document.classList.add('hide')
					} else {
						document.classList.remove('hide')
					}
				})
			}
		})
	})
})
